import React from 'react';
import Spinner from '../Spinner';
import styles from './styles.module.scss';

const SpinnerContainer = () => (
  <div className={styles.spinnerContainer}>
    <Spinner/>
  </div>
);

export default SpinnerContainer;
